<div class="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true" aria-labelledby="continue-export-title">
  <div class="absolute inset-0 bg-black/40" (click)="close()"></div>
  <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 mx-4">
    <h3 id="continue-export-title" class="font-semibold text-gray-900 mb-1">Continue export</h3>
    <p class="text-sm text-gray-500 mb-4">
      <span class="font-medium text-gray-700">{{ exp.summary_label }}</span>
      stopped at {{ offset | number }} leads because credits ran out. Part {{ nextPart }} picks up the list where it stopped
      <ng-container *ngIf="exp.remaining_count != null">and generates the remaining {{ target | number }} leads</ng-container>
      <ng-container *ngIf="exp.remaining_count == null">and generates up to ~{{ target | number }} more leads</ng-container>
      into a new Excel file with the same columns.
    </p>

    <label class="flex items-start gap-2 text-sm text-gray-700 mb-4" [class.opacity-60]="!emailColumn">
      <input type="checkbox" class="mt-0.5 rounded border-gray-300 text-violet-600 focus:ring-violet-500"
             [ngModel]="withEmails" (ngModelChange)="includeEmails = $event" [disabled]="isStarting || !emailColumn">
      <span *ngIf="emailColumn">Include emails — 2 credits per email found, nothing if not found</span>
      <span *ngIf="!emailColumn">Include emails — this export has no Email column</span>
    </label>

    <div class="rounded-lg bg-gray-50 border border-gray-100 p-3 text-sm text-gray-700 space-y-1 mb-3">
      <div class="flex justify-between">
        <span>Leads</span>
        <span>up to <span class="font-semibold">{{ leadsCost | number }}</span> credits</span>
      </div>
      <div class="flex justify-between" *ngIf="withEmails">
        <span>Emails</span>
        <span>up to <span class="font-semibold">{{ emailsCost | number }}</span> credits</span>
      </div>
      <div class="flex justify-between text-gray-500" *ngIf="balance !== null">
        <span>Current balance</span>
        <span>{{ balance | number }} credits</span>
      </div>
    </div>

    <p class="text-xs text-gray-500 mb-3">
      Priced as if the export had never stopped — you don't pay the starting price again. Billed as leads are generated; you only pay for leads delivered.
    </p>
    <p *ngIf="cannotStart" class="text-xs text-red-600 mb-3">You need at least {{ startCost | number }} credits to continue. Add credits, then try again.</p>
    <p *ngIf="!cannotStart && shortOfCredits" class="text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded px-2 py-1.5 mb-3">
      Your balance may not cover the rest. The export stops again when credits run out, and you can continue it later.
    </p>
    <p *ngIf="errorMessage" class="text-sm text-red-600 mb-3">{{ errorMessage }}</p>

    <div class="flex justify-end gap-2">
      <button type="button"
              class="px-4 py-2 rounded-lg border border-gray-300 text-sm text-gray-600 hover:bg-gray-50 disabled:opacity-50"
              [disabled]="isStarting" (click)="close()">
        Cancel
      </button>
      <button type="button"
              class="px-4 py-2 rounded-lg bg-violet-600 text-white text-sm font-medium hover:bg-violet-700 disabled:opacity-50 inline-flex items-center gap-2"
              [disabled]="isStarting || cannotStart" (click)="start()">
        <span *ngIf="isStarting" class="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"></span>
        {{ isStarting ? 'Starting…' : 'Continue export' }}
      </button>
    </div>
  </div>
</div>
